import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps, ScreenProperty } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import ToggleSwitch from '../../../../../../common/inputs/toggleSwitch/ToggleSwitch'
import { SCREEN_OTHER_FACILITIES, SCREENS } from '../../../../../../../services/domain/wizardScreens'
import WebViewParkingSpaceCount from './WebViewParkingSpaceCount'
import WebViewParkingSpaceRent from './WebViewParkingSpaceRent'
import WebViewParkingSpaceType from './WebViewParkingSpaceType'

export interface WebViewParkingSpaceProps extends FieldProps<OtherFacilitiesScreenValidationResult> {
  doReset: (clearingUpOf: ScreenProperty[]) => void
}

const WebViewParkingSpace: React.FC<WebViewParkingSpaceProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  doReset,
  wrapperClassName = 'grid-item one-whole margin-top-l',
}) => {
  const { t } = useTranslation()

  const [hasParkingSpace, setHasParkingSpace] = useState(
    !!insertionData.noParkingSpaces ||
      !!insertionData.parkingSpaceRent ||
      (insertionData.parkingSpaceType && insertionData.parkingSpaceType !== 'NONE')
  )

  const hasUsedParkingSpace =
    insertionData.noParkingSpaces ||
    insertionData.parkingSpaceRent ||
    (insertionData.parkingSpaceType && insertionData.parkingSpaceType !== 'NONE')

  useEffect(() => {
    if (hasUsedParkingSpace) {
      setHasParkingSpace(true)
    }
  }, [hasUsedParkingSpace])

  const handleToggleChange = (_field: string, value: boolean) => {
    setHasParkingSpace(value)

    // Reset parking space fields when toggling OFF
    if (!value) {
      doReset([
        { screen: SCREENS[SCREEN_OTHER_FACILITIES].name, property: 'noParkingSpaces' },
        { screen: SCREENS[SCREEN_OTHER_FACILITIES].name, property: 'parkingSpaceRent' },
        { screen: SCREENS[SCREEN_OTHER_FACILITIES].name, property: 'parkingSpaceType' },
      ])
    }
  }

  return (
    <div className={wrapperClassName}>
      <div className='grid'>
        <div className='grid-item'>
          <ToggleSwitch
            id='mobile-parking-space-toggle'
            propertyName='mobileParkingSpace'
            alignment='maxSpread'
            label={t('wizard.screen.otherFacilities.webViewParkingSpace.label')}
            value={hasParkingSpace || false}
            onChange={handleToggleChange}
          />
        </div>
        {hasParkingSpace && (
          <>
            <div className='grid-item one-whole margin-top-m'>
              <WebViewParkingSpaceCount
                insertionData={insertionData}
                validationMessages={validationMessages}
                screenName={screenName}
                onChange={onChange}
              />
            </div>
            <div className='grid-item one-whole margin-top-l'>
              <WebViewParkingSpaceRent
                insertionData={insertionData}
                validationMessages={validationMessages}
                screenName={screenName}
                onChange={onChange}
              />
            </div>
            <div className='grid-item one-whole margin-top-l'>
              <WebViewParkingSpaceType
                insertionData={insertionData}
                validationMessages={validationMessages}
                screenName={screenName}
                onChange={onChange}
              />
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default WebViewParkingSpace
